import React, { useState, useEffect, useRef } from 'react';
import { Container, Row, Button, Col, Tab, Tabs } from 'react-bootstrap';
import API from '../../api';
import Tools from '../../tools';
import ListDownloadButton from '../utils/ListDownloadButton';
import Enums from '../../enums';
import Loading from '../Loading';
import { ArcElement } from "chart.js";
import Chart from "chart.js/auto";
import ChartDataLabels from 'chartjs-plugin-datalabels';
import { Pie, Bar } from 'react-chartjs-2';
import { Download, BarChartFill, PieChartFill } from 'react-bootstrap-icons';
import ReactWordcloud from 'react-wordcloud';
import toImg from 'react-svg-to-image';

// Chart.register(ArcElement);
Chart.register(ChartDataLabels);
Chart.defaults.set('plugins.datalabels', {
    color: '#555'
});

export default function ProjAnswerChart(props) {
    const [isFetched, setIsFetched] = useState(false);
    const [answerDataList, setAnswerDataList] = useState([]);
    // const [answerHeaderList, setAnswerHeaderList] = useState([]);
    const [sortType, setSortType] = useState([]);
    const [hideIndexList, setHideIndexList] = useState([]);
    const [isLoading, setIsLoading] = useState([]);
    const refCanvas = useRef([]);
    const refCanvas2 = useRef([]);
    const refCanvas3 = useRef([]);

    useEffect(() => {
        // console.log("updated", isFetched);
        if (false == isFetched) {
            API.init({ props });
            Tools.init();
            getData();
        }
        setIsFetched(true);
    }, [isFetched]);

    function getData() {
        setIsLoading(true);
        let tmpData = {
            pi: props.pi
        };
        API.GetAnswerRecord(tmpData).
            then(onDataUpdated);
        // onDataUpdated({ "data": [{ "platform_point": 3000, "item_id": "IT210809111838", "item_type": "後台點數", "price": 15000, "item_name": "基礎版 15,000元(3000點)", "item_description": "適合偶爾了解市場訊息，議題很單純，想快速、小規模回收問卷的團隊" }, { "platform_point": 6000, "item_id": "IT210809112018", "item_type": "後台點數", "price": 27000, "item_name": "行銷版 27,000元(6000點)", "item_description": "適合所有行銷、客戶服務、計畫提案團隊，各項方案推行前率先掌握市場資訊" }, { "platform_point": 12000, "item_id": "IT210809112146", "item_type": "後台點數", "price": 48000, "item_name": "企業版 48,000元(12000點)", "item_description": "適合大型企業、有定期產品開發、企劃設計需求，固定週期蒐集消費者反饋" }] });
    }

    function onDataUpdated(data) {
        setIsLoading(false);
        // console.log("[!]", data);
        // setIsAdmin(API.getIsAdmin());
        if (data && data.responseData
            && data.responseData.data && data.responseData.data.length > 0
            && data.responseData.header && data.responseData.header.length > 0) {
            // console.log(data.responseData.data);
            // console.log(data.responseData.header);
            if (setSortType.length == 0) {
                setSortType(Array(data.responseData.data.length).fill(Enums.ESORT.STR));
                setHideIndexList(Array(data.responseData.header.length).fill(false));
            }

            try{
                // list=[
                //     {data:[value]}
                // ]
                const toPercentage = (val)=>{
                    return (val*100).toFixed(1)+"%"
                }

                const sourceHeader = data.responseData.header;
                const sourceData = data.responseData.data;
                const sourceType = data.responseData.q_type;
                let questionLength = sourceData[0].length;
                let answerLength = sourceData.length;
                let tmpList=[];
                for( let i=1; i<questionLength; i++){
                    let title = sourceHeader[i];
                    let currentType = sourceType[i];
                    let tmpDictionary=[];
                    if( currentType!=2 ){
                        for( let j=0; j<answerLength; j++){
                            let ans = sourceData[j][i];
                            if(tmpDictionary.hasOwnProperty(ans)){
                                tmpDictionary[ans]++;
                            } else {
                                tmpDictionary[ans]=1;
                            }
                        }
                    } else {
                        for( let j=0; j<answerLength; j++){
                            let ansList = sourceData[j][i].split(",");
                            ansList.forEach(ans=>{
                                if(tmpDictionary.hasOwnProperty(ans)){
                                    tmpDictionary[ans]++;
                                } else {
                                    tmpDictionary[ans]=1;
                                }
                            })
                        }
                    }

                    
                    let tmpDataAry=[],
                        tmpHeader=[],
                        tmpChartDataAryForPie=[],
                        tmpChartHeaderAryForPie=[],
                        tmpChartDataAryForBar=[],
                        tmpChartHeaderAryForBar=[],
                        tmpTextCloud=[],
                        otherCnt=0;

                    Object.keys(tmpDictionary).forEach((key)=>{
                        let cnts=tmpDictionary[key];
                        tmpDataAry.push({data:[key, cnts, toPercentage(cnts/answerLength)]});
                    });
                    tmpDataAry = tmpDataAry.sort((a,b)=>{
                        return b.data[1]-a.data[1]
                    });
    
                    tmpDataAry.forEach((obj,index)=>{
                        tmpTextCloud.push({
                            text: obj.data[0],
                            value: obj.data[1]
                        });
                        tmpHeader.push(obj.data[0]);
                        
                        if(index<10){
                            tmpChartHeaderAryForPie.push((obj.data[0].length>10)?(obj.data[0].substring(0,10)+".."):obj.data[0]);
                            tmpChartDataAryForPie.push(obj.data[1]);
                        } else otherCnt+=obj.data[1];
                        tmpChartHeaderAryForBar.push(obj.data[0]);
                        tmpChartDataAryForBar.push(obj.data[1]);
                    })
                    if( otherCnt>0 ){
                        tmpChartHeaderAryForPie.push("其他選項");
                        tmpChartDataAryForPie.push(otherCnt);
                    }
                    /*[
                        {data:[]}
                    ]*/
                    // console.log(tmpDictionary, tmpDictionary.length, tmpDataAry);

                    tmpList.push({
                        key: i,
                        title: title, //(index < data.responseData.header.length) ? data.responseData.header[index]:"",
                        // data: [tmpDictionary],
                        // data: [{data:Object.values(tmpDictionary)}],
                        data: tmpDataAry,
                        chartDataForPie: tmpChartDataAryForPie,
                        chartHeaderForPie: tmpChartHeaderAryForPie,
                        chartDataForBar: tmpChartDataAryForBar,
                        chartHeaderForBar: tmpChartHeaderAryForBar,
                        header: Object.keys(tmpDictionary),
                        textCloudData: tmpTextCloud,
                        sampleNum: answerLength
                    });
                }
                setAnswerDataList(tmpList);
            } catch(e){
                console.log(e.stack);
            }
            // setAnswerHeaderList(data.responseData.header);
            // props.cookies.set('usr', data.display_name, { path: '/' });
        }
        // setIsInit(true);
    }

    function downloadCanvas(index, refAry, fileName){
        console.log(refAry, index);
        console.log(refAry.current[index].ctx.canvas);
        const chartCanvas = refAry.current[index].ctx.canvas;
        if (chartCanvas) {
          const url = chartCanvas.toDataURL("image/png");
          const link = document.createElement("a");
          link.download = fileName;
          link.href = url;
          link.click();
        }
    }

    // function copyStylesInline(destinationNode, sourceNode) {
    //     var containerElements = ["svg","g"];
    //     for (var cd = 0; cd < destinationNode.childNodes.length; cd++) {
    //         var child = destinationNode.childNodes[cd];
    //         if (containerElements.indexOf(child.tagName) != -1) {
    //              copyStylesInline(child, sourceNode.childNodes[cd]);
    //              continue;
    //         }
    //         var style = sourceNode.childNodes[cd].currentStyle || window.getComputedStyle(sourceNode.childNodes[cd]);
    //         if (style == "undefined" || style == null) continue;
    //         for (var st = 0; st < style.length; st++){
    //              child.style.setProperty(style[st], style.getPropertyValue(style[st]));
    //         }
    //     }
    // }

    // function triggerDownload (imgURI, fileName) {
    //     var evt = new MouseEvent("click", {
    //       view: window,
    //       bubbles: false,
    //       cancelable: true
    //     });
    //     var a = document.createElement("a");
    //     a.setAttribute("download", fileName);
    //     a.setAttribute("href", imgURI);
    //     a.setAttribute("target", '_blank');
    //     a.dispatchEvent(evt);
    // }

    var generateQuerySelector = function(el) {
        if (el.tagName.toLowerCase() == "html")
            return "HTML";
        var str = el.tagName;
        str += (el.id != "") ? "#" + el.id : "";
        if (el.className) {
            var classes = el.className.split(/\s/);
            for (var i = 0; i < classes.length; i++) {
                str += "." + classes[i]
            }
        }
        return generateQuerySelector(el.parentNode) + " > " + str;
    }

    // function downloadSvg(index, refAry, fileName){
    //     const svg = refAry.current[index].childNodes[0].childNodes[0];
    //     if (svg) {
    //         var copy = svg.cloneNode(true);
    //         copyStylesInline(copy, svg);
    //         var canvas = document.createElement("canvas");
    //         var bbox = svg.getBBox();
    //         canvas.width = bbox.width;
    //         canvas.height = bbox.height;
    //         var ctx = canvas.getContext("2d");
    //         ctx.clearRect(0, 0, bbox.width, bbox.height);
    //         var data = (new XMLSerializer()).serializeToString(copy);
    //         var DOMURL = window.URL || window.webkitURL || window;
    //         var img = new Image();
    //         var svgBlob = new Blob([data], {type: "image/svg+xml;charset=utf-8"});
    //         var url = DOMURL.createObjectURL(svgBlob);
    //         img.onload = function () {
    //             ctx.drawImage(img, 0, 0);
    //             DOMURL.revokeObjectURL(url);
    //             if (typeof navigator !== "undefined" && navigator.msSaveOrOpenBlob)
    //             {
    //                 var blob = canvas.msToBlob();         
    //                 navigator.msSaveOrOpenBlob(blob, fileName);
    //             } 
    //             else {
    //                 var imgURI = canvas
    //                     .toDataURL("image/png")
    //                     .replace("image/png", "image/octet-stream");
    //                 triggerDownload(imgURI, fileName);
    //             }
    //             // document.removeChild(canvas);
    //         };
    //         img.src = url;
    //     }
    // }

    function render() {
        let tmpList = [];
        answerDataList.forEach((obj, idx)=>{
            // console.log(idx, obj);
            let dataForPie = {
                labels: obj.chartHeaderForPie,
                datasets: [{
                    label: "計數",
                    data: obj.chartDataForPie,
                    backgroundColor: [
                    // '#1ca2e9',
                    // '#6eaeed',
                    // '#9cb9f1',
                    // '#bfc0f3',
                    // '#ccc3f4',
                    // '#ddc6f4',
                        '#99f4c4',
                        '#99c9f4',
                        '#c499f4',
                        '#f499c9',
                        '#f4c499',
                        '#c9f499',
                        '#76717b',
                        '#6cbcec',
                        '#4d306d',
                        '#d3bf72',
                        '#c499f4',
                    ],
                    hoverBackgroundColor: [
                    // '#1ca2e9',
                    // '#6eaeed',
                    // '#9cb9f1',
                    // '#bfc0f3',
                    // '#ccc3f4',
                    // '#ddc6f4',
                        '#b7f3d3',
                        '#c0e0fd',
                        '#d8b8fc',
                        '#fab8db',
                        '#f9d9bd',
                        '#d7f5b5',
                        '#a3a0a6',
                        '#8ecaee',
                        '#684d85',
                        '#d9cb95',
                        '#d8b8fc',
                    ]
                }]
            };

            let dataForBar = {
                labels: obj.chartHeaderForBar,
                datasets: [{
                    label: "計數",
                    data: obj.chartDataForBar,
                    backgroundColor: [
                    // '#1ca2e9',
                    // '#6eaeed',
                    // '#9cb9f1',
                    // '#bfc0f3',
                    // '#ccc3f4',
                    // '#ddc6f4',
                        '#99f4c4',
                        '#99c9f4',
                        '#c499f4',
                        '#f499c9',
                        '#f4c499',
                        '#c9f499',
                        '#76717b',
                        '#6cbcec',
                        '#4d306d',
                        '#d3bf72',
                    ],
                    hoverBackgroundColor: [
                    // '#1ca2e9',
                    // '#6eaeed',
                    // '#9cb9f1',
                    // '#bfc0f3',
                    // '#ccc3f4',
                    // '#ddc6f4',
                        '#b7f3d3',
                        '#c0e0fd',
                        '#d8b8fc',
                        '#fab8db',
                        '#f9d9bd',
                        '#d7f5b5',
                        '#a3a0a6',
                        '#8ecaee',
                        '#684d85',
                        '#d9cb95',
                    ]
                }]
            };
            
            tmpList.push((
                <Row key={"chart-"+idx} className="margin-bottom-30">
                    <Col xs={12} lg={7}>
                        <ListDownloadButton key={"ldb-"+idx} list={(null != obj.data) ? obj.data : []}
                            fields={["選項","次數","百分比"]}
                            title={obj.title||"下載報表"}
                            sampleNum={obj.sampleNum}
                            fileName={"answerRecord_" + props.pi+"_q"+(idx+1)+"_"+obj.title}
                        />
                    </Col>
                    <Col xs={12} lg={5} style={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                    }}>
                        <Container>
                        <Tabs
                            defaultActiveKey="home"
                            id="fill-tab-example"
                            className="mb-3"
                            justify
                        >
                            <Tab eventKey="home" title="圓餅圖">
                                <div className='text-right'>
                                    <Button variant="link"
                                    onClick={()=>{downloadCanvas(idx, refCanvas, ("answerRecord_" + props.pi+"_q"+(idx+1)+"_"+obj.title+".png")) } }><Download/></Button>
                                </div>
                                <Pie data={dataForPie}
                                    ref={el => (refCanvas.current = [...refCanvas.current, el])}
                                    options={{
                                        // plugins: [ChartDataLabels],
                                        plugins: {
                                            datalabels: {
                                                formatter: (value, ctx) => {
                                                    let sum = 0;
                                                    let dataArr = ctx.chart.data.datasets[0].data;
                                                    dataArr.map(data => {
                                                        sum += data;
                                                    });
                                                    let percentage = (value*100 / sum).toFixed(2)+"%";
                                                    // return ctx.chart.data.labels[ctx.dataIndex]+"\n"+value+"\n"+percentage;
                                                    return percentage;
                                                },
                                                textAlign: 'center',
                                                font:{
                                                    size: 15,
                                                    weight: 'bold'
                                                }
                                                // color: "#333"
                                            },
                                            legend: {
                                                display: false
                                            }
                                        }
                                    }}/>
                            </Tab>
                            <Tab eventKey="profile" title="長條圖">
                                <div className='text-right'>
                                    <Button variant="link"
                                        onClick={()=>{downloadCanvas(idx, refCanvas2, ("answerRecord_" + props.pi+"_q"+(idx+1)+"_"+obj.title+".png")) } }><Download/></Button>
                                </div>
                                <Bar data={dataForBar}
                                    ref={el => (refCanvas2.current = [...refCanvas2.current, el])}
                                    options={{
                                        aspectRatio: 1,
                                        plugins: {
                                            datalabels: {
                                                formatter: (value, ctx) => {
                                                    let sum = 0;
                                                    let dataArr = ctx.chart.data.datasets[0].data;
                                                    dataArr.map(data => {
                                                        sum += data;
                                                    });
                                                    let percentage = (value*100 / sum).toFixed(2)+"%";
                                                    // return ctx.chart.data.labels[ctx.dataIndex]+"\n"+value+"\n"+percentage;
                                                    return percentage;
                                                },
                                                align: 'top',
                                                textAlign: 'center',
                                                font:{
                                                    size: 15,
                                                    weight: 'bold'
                                                },
                                                // textStrokeColor: '#aaa',
                                                // textStrokeWidth: 2
                                            },
                                            legend: {
                                                display: false
                                            }
                                        }
                                    }}/>
                            </Tab>
                            {/* <Tab eventKey="contact" title="文字雲">
                                {0==idx?(
                                    <>
                                    <div className='text-right'>
                                        <Button
                                            onClick={()=>{downloadSvg(idx, refCanvas3, ("answerRecord_" + props.pi+"_q"+(idx+1)+"_"+obj.title+".png")) } }><Download/></Button>
                                    </div>
                                    <div ref={el => (refCanvas3.current = [...refCanvas3.current, el])}>
                                    <ReactWordcloud 
                                        words={obj.textCloudData}
                                        options={{
                                            rotations:0,
                                            scale: 1.2,
                                            enableTooltip: false,
                                            fontSizes:[20, 60]
                                        }}
                                    />
                                    </div>
                                    </>
                                ):null}
                            </Tab> */}
                        </Tabs>
                        </Container>
                    </Col>
                    <br/>
                </Row>
            ));
            
        });

        return (
            <div className="Row">
                {tmpList}
                <Loading isLoading={isLoading} />
            </div>
        );
    }
    return render();
}